import { render, staticRenderFns } from "./UpgradeList.vue?vue&type=template&id=8af1f55e&scoped=true&"
import script from "./UpgradeList.vue?vue&type=script&lang=js&"
export * from "./UpgradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af1f55e",
  null
  
)

export default component.exports